var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfodifetti1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_20762",
    "data-name": "Raggruppa 20762",
    transform: "translate(-987 1960)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_10947",
    "data-name": "Rettangolo 10947",
    width: 23,
    height: 23,
    rx: 3,
    transform: "translate(987 -1960)",
    fill: "#3260ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-expand-arrows-alt",
    "data-name": "Icon awesome-expand-arrows-alt",
    d: "M12.468,10.933V14.05a.666.666,0,0,1-.668.668H8.683a.669.669,0,0,1-.473-1.141L9.218,12.57,6.234,9.586l-1.1-1.1L2.148,5.5,1.141,6.508A.669.669,0,0,1,0,6.035V2.918A.666.666,0,0,1,.668,2.25H3.785a.669.669,0,0,1,.473,1.141L3.251,4.4,6.234,7.382l1.1,1.1L10.32,11.47l1.007-1.007A.667.667,0,0,1,12.468,10.933Z",
    transform: "translate(992.146 -1957.104)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfodifetti1);
export default __webpack_public_path__ + "static/media/infodifetti1.8522a62c934e94929ed43ba10b022fc5.svg";
export { ForwardRef as ReactComponent };